import Vue from "vue";
import App from "./App.vue";
import router from "./router/router";
import store from "./vuex/store";
import vuetify from "./plugins/vuetify";
import brandUtilitiesPlugin from "./plugins/brandUtilities";
import VueTour from "vue-tour";
import VueObserveVisibility from "vue-observe-visibility";
import LineClamp from "vue-line-clamp";
import VuePlyr from "vue-plyr";
import LoadScript from "vue-plugin-load-script";
import { Drag, Drop } from "vue-drag-drop";
import VueThreeSixty from "vue-360";
import "vue-360/dist/css/style.css";
import "vue-plyr/dist/vue-plyr.css";
import offlineConfig from "./config/offlineMode";
import { setupOfflineInterceptors } from "./config/axiosOfflineInterceptor";
import { setupAxiosAuthInterceptor } from "./config/axiosAuthInterceptor";

// Import Montserrat font
import "@fontsource/montserrat/400.css"; // Regular weight
import "@fontsource/montserrat/600.css"; // Semi-bold weight
import "@fontsource/montserrat/700.css"; // Bold weight

Vue.config.productionTip = false;

// Initialize offline mode if enabled
if (offlineConfig.isOfflineMode) {
  console.log("🔌 AssetXP Offline Mode Enabled");
  console.log("   - Authentication bypass:", offlineConfig.bypassAuth);
  console.log("   - SSL disabled:", offlineConfig.disableSSL);
  console.log("   - Using mock data:", offlineConfig.useMockData);

  // Setup axios interceptors for offline mode
  setupOfflineInterceptors();
}

// Fresh Bearer token on every axios request (UserManager first; Vuex fallback)
setupAxiosAuthInterceptor();

Vue.config.ignoredElements = ["babylon"];

require("vue-tour/dist/vue-tour.css");

// Install brand utilities plugin early so CSS variables and utility classes are available
Vue.use(brandUtilitiesPlugin);

Vue.component("drag", Drag);
Vue.component("drop", Drop);
Vue.config.productionTip = false;
Vue.use(VueTour);
Vue.use(VueObserveVisibility); // This is used by the Babylon viewer
Vue.use(LineClamp, {
  importCss: true,
});
Vue.use(VueThreeSixty);
Vue.use(LoadScript);
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: false },
  },
  emit: ["ended"],
});

new Vue({
  router,
  store,
  vuetify,
  VueTour,
  LineClamp,
  render: (h) => h(App),
}).$mount("#app");
